module.exports = __webpack_public_path__ + "img/user.9f891673.png";